export const GET_ARTICLES = "GET_ARTICLES";
export const GET_ARTICLES_SUCCESS = "GET_ARTICLES_SUCCESS";
export const GET_ARTICLES_FAILED = "GET_ARTICLES_FAILED";
export const GET_ARTICLES_RESET = "GET_ARTICLES_RESET";

// update status
export const UPDATE_STATUS_ARTICLES = "UPDATE_STATUS_ARTICLES";
export const UPDATE_STATUS_ARTICLES_SUCCESS = "UPDATE_STATUS_ARTICLES_SUCCESS";
export const UPDATE_STATUS_ARTICLES_FAILED = "UPDATE_STATUS_ARTICLES_FAILED";

// create
export const CREATE_ARTICLES = "CREATE_ARTICLES";
export const CREATE_ARTICLES_SUCCESS = "CREATE_ARTICLES_SUCCESS";
export const CREATE_ARTICLES_FAILED = "CREATE_ARTICLES_FAILED";

// update
export const UPDATE_ARTICLES = "UPDATE_ARTICLES";
export const UPDATE_ARTICLES_SUCCESS = "UPDATE_ARTICLES_SUCCESS";
export const UPDATE_ARTICLES_FAILED = "UPDATE_ARTICLES_FAILED";

// get detail 
export const GET_DETAIL_ARTICLES = "GET_DETAIL_ARTICLES";
export const GET_DETAIL_ARTICLES_SUCCESS = "GET_DETAIL_ARTICLES_SUCCESS";
export const GET_DETAIL_ARTICLES_FAILED = "GET_DETAIL_ARTICLES_FAILED";
export const GET_DETAIL_ARTICLES_RESET = "GET_DETAIL_ARTICLES_RESET";



/**
 * @param {object} payload
 * @param {function} onSuccess Callback function on success
 * @param {function} onError Callback function on error
 */

export function actGetListArticles(payload, onSuccess, onError) {
    return {
        type: GET_ARTICLES,
        payload: payload,
        onSuccess: onSuccess,
        onError: onError,
    }
}

export function actGetListArticlesSuccess(payload) {
    return {
        type: GET_ARTICLES_SUCCESS,
        payload: payload,
    }
}

export function actGetListArticlesFailed() {
    return {
        type: GET_ARTICLES_FAILED,
    }
}

export function actGetListArticlesReset() {
    return {
        type: GET_ARTICLES_RESET,
    }
}


/// update status
/**
 * @param {object} payload
 * @param {function} onSuccess Callback function on success
 * @param {function} onError Callback function on error
 */

export function actUpdateStatusArticles(payload, onSuccess, onError) {
    return {
        type: UPDATE_STATUS_ARTICLES,
        payload: payload,
        onSuccess: onSuccess,
        onError: onError,
    }
}

export function actUpdateStatusArticlesSuccess(payload) {
    return {
        type: UPDATE_STATUS_ARTICLES_SUCCESS,
        payload: payload,
    }
}

export function actUpdateStatusArticlesFailed() {
    return {
        type: UPDATE_STATUS_ARTICLES_FAILED,
    }
}


// create
export function actCreateArticles(payload, onSuccess, onError) {
    return {
        type: CREATE_ARTICLES,
        payload: payload,
        onSuccess: onSuccess,
        onError: onError,
    }
}

export function actCreateArticlesSuccess(payload) {
    return {
        type: CREATE_ARTICLES_SUCCESS,
        payload: payload,
    }
}

export function actCreateArticlesFailed() {
    return {
        type: CREATE_ARTICLES_FAILED,
    }
}

// update
export function actUpdateArticles(payload, onSuccess, onError) {
    return {
        type: UPDATE_ARTICLES,
        payload: payload,
        onSuccess: onSuccess,
        onError: onError,
    }
}

export function actUpdateArticlesSuccess(payload) {
    return {
        type: UPDATE_ARTICLES_SUCCESS,
        payload: payload,
    }
}

export function actUpdateArticlesFailed() {
    return {
        type: UPDATE_ARTICLES_FAILED,
    }
}

// get detail

export function actGetDetailArticles(payload, onSuccess, onError) {
    return {
        type: GET_DETAIL_ARTICLES,
        payload: payload,
        onSuccess: onSuccess,
        onError: onError,
    }
}

export function actGetDetailArticlesSuccess(payload) {
    return {
        type: GET_DETAIL_ARTICLES_SUCCESS,
        payload: payload,
    }
}

export function actGetDetailArticlesFailed() {
    return {
        type: GET_DETAIL_ARTICLES_FAILED,
    }
}

export function actGetDetailArticlesReset() {
    return {
        type: GET_DETAIL_ARTICLES_RESET,
    }
}



export default {
    actGetListArticles,
    actGetListArticlesSuccess,
    actGetListArticlesFailed,
    actGetListArticlesReset,
    // update status
    actUpdateStatusArticles,
    actUpdateStatusArticlesSuccess,
    actUpdateStatusArticlesFailed,
    // create
    actCreateArticles,
    actCreateArticlesSuccess,
    actCreateArticlesFailed,
    // update
    actUpdateArticles,
    actUpdateArticlesSuccess,
    actUpdateArticlesFailed,
    // get detail
    actGetDetailArticles,
    actGetDetailArticlesSuccess,
    actGetDetailArticlesFailed,
    actGetDetailArticlesReset,
}